// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"kH","legalMessage":"kI","navLink":"kJ","bottomLinkWrapper":"kK","bottomLink":"kL kJ"};